<on-page-title
    icon="fa-cogs"
    [title]="'company.accountant.settings' | translate"
>
</on-page-title>

<on-accountant-administration
    #AccountantAdministration
></on-accountant-administration>
